import { useState } from 'react'
import { useEffect } from 'react'

import { bottles } from 'src/axious/bottles'
import { BottleType } from 'src/pages/Bottle/Bottles.types'
import { handleAxiosError } from 'src/utils/errorHandling'

export const useGetLotteryBottle = () => {
  const [lotteryBottle, setLotteryBottle] = useState<BottleType | null>(null)

  useEffect(() => {
    const getLotteryBottle = async () => {
      try {
        const res = await bottles('GET', '/lottery/active')

        setLotteryBottle(res as BottleType)
      } catch (err) {
        const errorMessage = handleAxiosError(err)
        console.log(errorMessage)
      }
    }

    getLotteryBottle()
  }, [])

  return { lotteryBottle }
}
